import React, { useCallback, useContext, useEffect, useReducer } from "react";
import { RotatingLines } from "react-loader-spinner";
import { toast } from "react-toastify";
import Footer from "../components/Footer";
import Header from "../components/Header";

const Context = React.createContext();

export const useAuth = () => useContext(Context);

const INITIAL_STATE = {
	isAuth: false,
	authUser: undefined,
	initialized: false,
};

const authReducer = (state, action) => {
	switch (action.type) {
		case "AUTH_SUCCESS": {
			const { authUser } = action.payload;
			return {
				...state,
				isAuth: true,
				authUser,
				initialized: true,
			};
		}
		case "AUTH_FAILED": {
			return {
				...state,
				isAuth: false,
				initialized: true,
			};
		}
		case "AUTH_LOGOUT": {
			return {
				...state,
				isAuth: false,
			};
		}
		default: {
			return state;
		}
	}
};

export default function AuthProvider({ children }) {
	const [state, dispatch] = useReducer(authReducer, INITIAL_STATE);

	const getUser = useCallback(() => {
		fetch("/api/auth/user", {
			credentials: "include",
			headers: {
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch({
					type: "AUTH_SUCCESS",
					payload: {
						authUser: {
							...data,
						},
					},
				});
			})
			.catch(() => {
				dispatch({
					type: "AUTH_FAILED",
				});
			});
	}, []);

	const onLogout = () => {
		fetch("/api/auth/logout", {
			method: "POST",
			credentials: "include",
			headers: {
				"Content-Type": "application/json",
			},
		})
			.then((res) => {
				if (res.ok) {
					dispatch({
						type: "AUTH_LOGOUT",
					});

					const logoutRedirectUrl =
						process.env.NODE_ENV === "development"
							? `&post_logout_redirect_uri=${window.location.origin}`
							: `/?url=${window.location.origin}`;
					window.location.href = `${state.authUser.logoutUrl}${logoutRedirectUrl}`;
				} else {
					throw res;
				}
			})
			.catch(() => {
				toast.error("Κάτι πήγε στραβά κατά την διαδικασία της αποσύνδεσης. Παρακαλώ προσπαθήστε ξανά αργότερα.");
			});
	};

	useEffect(() => {
		getUser();
	}, [getUser]);

	const contextValue = { ...state, onLogout };

	return (
		<>
			<Header contextValue={contextValue} />
			{state.initialized ? (
				<Context.Provider value={contextValue}>{children}</Context.Provider>
			) : (
				<main id="main-content" className="content d-flex flex-fill justify-content-center align-items-center" tabIndex="-1">
					<output aria-live="polite" aria-label="Γίνεται φόρτωση των στοιχείων σας" className="text-center">
						<span className="visually-hidden">Γίνεται φόρτωση των στοιχείων σας.</span>
						<RotatingLines
							visible={true}
							height="96"
							width="96"
							color="grey"
							strokeWidth="5"
							strokeColor="#003476"
							animationDuration="0.75"
							ariaLabel="Γίνεται φόρτωση των στοιχείων σας"
						/>
					</output>
				</main>
			)}
			<Footer />
		</>
	);
}
